module.exports = __webpack_public_path__ + "static/media/mlVerticalHVA.867d73af.png";